/**
 * AddCartButton，加购按钮，点击元素本身触发
 * 
 * Attributes:
 * @param {String} data-variant-id 产品变体 ID
 * @param {String} data-quantity 购买数量，可选，默认为1
 * 
 * @example 
 * ```html
 * <add-cart-button data-variant-id="{{ product.first_available_variant.id }}" data-quantity="1" class="button round">
 *   Add to cart
 *   {%- render 'loading-spinner' -%}
 * </add-cart-button>
 * ```
 */
if (!customElements.get('add-cart-button')) {
  class AddCartButton extends HTMLElement {
    // 标记
    _marks = {
      loading: "loading"
    };

    _shopify_features_script = document.querySelector("script[id='shopify-features']");
    _shopify_features_json = JSON.parse(this._shopify_features_script.innerHTML);
    _checkout_headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'authorization': 'Basic ' + btoa(this._shopify_features_json.accessToken)
    };

    get _variantId () { return this.getAttribute("data-variant-id") }
    get _quantity () { return this.getAttribute("data-quantity") ?? 1 }

    constructor() {
      super();
    }

    connectedCallback () {
      this.elements = {
        loadingSpinner: this.querySelector(".loading__spinner"),
      };
      this.addEventListener('click', (e) => {
        if (!this.classList.contains('disabled')) {
          this.startLoading();
          this.addToCart().finally(() => {
            this.finishLoading();
          });
        }
      });
    }

    /**
     * 加购
     */
    async addToCart () {
      let data_json = {
        form_type: "product",
        quantity: this._quantity,
        utf8: "✓",
        id: this._variantId,
      }
      let data = JSON.stringify(data_json);
      return fetch("/cart/add.json",
        {
          method: 'POST',
          headers: this._checkout_headers,
          body: data
        }
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
      }).then((response) => {
        return this.updateCart(response);
      }).catch((err) => {
        console.error(err);
      });
    }

    /**
     * 更新购物车，并弹出侧边购物车
     * @returns 
     */
    async updateCart (response) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: this._variantId,
        cartData: response,
      });
      document.querySelector("cart-drawer").open();

      if ($(".cart-items").length < 1) {
        $(`cart-drawer`).removeClass("is-empty");
        $("cart-drawer-items").removeClass("is-empty");
        $(".drawer__inner-empty").remove();
        $("#CartDrawer-Checkout").removeAttr("disabled");
        // 赠品/数量同步未落定时保持禁用（见 assets/cart.js 的 cartCheckoutLock）
        window.cartCheckoutLock?.sync();
      }

      // fetch(`${routes.cart_url}?section_id=cart-drawer`)
      //   .then((response) => response.text())
      //   .then((responseText) => {
      //     const html = new DOMParser().parseFromString(responseText, 'text/html');
      //     const selectors = ['cart-drawer-items', '.cart-drawer__footer','.cart-count-update span'];
      //     for (const selector of selectors) {
      //       const targetElement = document.querySelector(selector);
      //       const sourceElement = html.querySelector(selector);
      //       if (targetElement && sourceElement) {
      //         targetElement.replaceWith(sourceElement);
      //       }
      //     }
      //     $('.drawer__header .cart-count-update span').text($('.cart-count-bubble span').eq(0).text())
      //   })
      //   .catch((e) => {
      //     console.error(e);
      //   });
    }

    startLoading () {
      this.setAttribute("aria-disabled", true);
      this.classList.add(this._marks.loading);
      this.elements.loadingSpinner?.classList.remove("hidden");
    }

    finishLoading () {
      this.removeAttribute("aria-disabled");
      this.classList.remove(this._marks.loading);
      this.elements.loadingSpinner?.classList.add("hidden");
    }
  }

  customElements.define('add-cart-button', AddCartButton);
}
